import { CheckCircle } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useEffect } from "react";

const ThankYou = () => {
  useEffect(() => {
    // Limpa qualquer token da URL ao carregar a página
    window.history.replaceState({}, document.title, "/thank-you");
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-success/5 to-success/10 p-4">
      <Card className="w-full max-w-2xl">
        <CardHeader className="text-center">
          <CheckCircle className="h-16 w-16 text-success mx-auto mb-4" />
          <CardTitle className="text-3xl text-success">
            ✅ Contrato Assinado com Sucesso!
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="text-center space-y-4">
            <p className="text-lg">
              Sua assinatura digital foi registrada com sucesso!
            </p>
            
            <div className="bg-muted p-6 rounded-lg space-y-3 text-left">
              <p className="font-semibold text-lg">📋 Próximos Passos:</p>
              <ul className="space-y-2 text-muted-foreground">
                <li>✓ Você receberá uma cópia do contrato por e-mail em breve</li>
                <li>✓ O contrato já está ativo e válido</li>
                <li>✓ Em caso de dúvidas, entre em contato conosco</li>
              </ul>
            </div>

            <div className="pt-4">
              <Button 
                onClick={() => window.close()}
                variant="outline"
                className="w-full sm:w-auto"
              >
                Fechar Janela
              </Button>
            </div>

            <p className="text-sm text-muted-foreground pt-4">
              Obrigado pela sua confiança! 🎉
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ThankYou;
